const fileManagerSx = theme => ({
	root: {
		display: "flex",
	},
	grow: {
		flexGrow: 1,
	},
	closeButton: {
		marginLeft: 0,
		marginRight: 20,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
	},
	content: {
		flex: 1,
		flexGrow: 1,
		padding: theme.spacing(2),
		overflowY: 'auto',
	},
	fullHeight: {
		height: '100%',
	},
});

export default fileManagerSx;
